// Oil Service Schedule — extracted from "Oil Service SCH.pdf"
// Maintenance intervals in *1,000 km (e.g. 5 = 5,000 km)
// Actions: I=Inspect, T=Tighten, L=Lubricate, R=Replace, A=Adjust

const SERVICE_SCHEDULE = [
  // ── Fifth Wheel ──
  {
    system: "Fifth Wheel",
    item: "Check fastening bolts (fifth wheel to base plate & frame)",
    action_cycle: { default: "I", intervals: { 5: "T", 15: "T", 25: "T", 35: "T", 45: "T", 55: "T", 65: "T", 75: "T", 85: "T", 95: "T" } },
    period_km: 5000,
  },
  {
    system: "Fifth Wheel",
    item: "Check wear of fifth wheel support shaft",
    action_cycle: { default: "L" },
    period_km: 5000,
  },
  {
    system: "Fifth Wheel",
    item: "Check wear of rubber bushing for support shaft",
    action_cycle: { default: "I" },
    period_km: 5000,
  },
  {
    system: "Fifth Wheel",
    item: "Check wear of drawbar pin and shaft clamping plate",
    action_cycle: { default: "L" },
    period_km: 5000,
  },

  // ── Traction Battery ──
  {
    system: "Traction Battery",
    item: "Check battery case pipe connector",
    action_cycle: { default: "I" },
    period_km: 5000,
  },
  {
    system: "Traction Battery",
    item: "Check battery frame mounting bolts",
    action_cycle: { default: "I" },
    period_km: 5000,
  },
  {
    system: "Traction Battery",
    item: "Check battery frame skin",
    action_cycle: { default: "I", intervals: { 15: "T", 35: "T", 55: "T", 75: "T", 100: "T" } },
    period_km: 5000,
  },
  {
    system: "Traction Battery",
    item: "Check traction battery mounting bolts",
    action_cycle: { default: "I" },
    period_km: 5000,
  },
  {
    system: "Traction Battery",
    item: "Check battery case deformation",
    action_cycle: { default: "I" },
    period_km: 5000,
  },
  {
    system: "Traction Battery",
    item: "Check motor harness connector",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or every 3 months",
  },

  // ── Motor ──
  {
    system: "Motor",
    item: "Check motor cooling pipe and joint for leakage",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or every 3 months",
  },
  {
    system: "Motor",
    item: "Clean the motor surface",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or every 3 months",
  },
  {
    system: "Motor",
    item: "Check motor suspension mounting bolts",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or every 3 months",
  },
  {
    system: "Motor",
    item: "Check motor ground wire connection",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or every 3 months",
  },

  // ── Transmission ──
  {
    system: "Transmission",
    item: "Change transmission lubricating oil",
    action_cycle: { default: "-", intervals: { 5: "R", 60: "R" } },
    period_km: 60000,
    remark: "First at 5,000 km; then every 60,000 km or 12 months",
  },
  {
    system: "Transmission",
    item: "Check transmission lubricating oil level",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or every 3 months",
  },
  {
    system: "Transmission",
    item: "Check transmission breather plug",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or every 3 months",
  },
  {
    system: "Transmission",
    item: "Check transmission control mechanism",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or every 3 months",
  },
  {
    system: "Transmission",
    item: "Check for oil and air leakage",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or every 3 months",
  },

  // ── PEU ──
  {
    system: "PEU",
    item: "Check connection part",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or every 3 months",
  },
  {
    system: "PEU",
    item: "High and low voltage connectors",
    action_cycle: { default: "I" },
    period_km: 5000,
  },
  {
    system: "PEU",
    item: "Check coolant leakage around system",
    action_cycle: { default: "I" },
    period_km: 5000,
  },
  {
    system: "PEU",
    item: "System mounting bolts",
    action_cycle: { default: "I", intervals: { 15: "T", 35: "T", 50: "T", 65: "T", 80: "T", 100: "T" } },
    period_km: 5000,
  },
  {
    system: "PEU",
    item: "Check enclosure grounding wire connection",
    action_cycle: { default: "I", intervals: { 15: "T", 35: "T", 50: "T", 65: "T", 80: "T", 100: "T" } },
    period_km: 5000,
  },
  {
    system: "PEU",
    item: "Check cover plate fastening",
    action_cycle: { default: "I", intervals: { 15: "T", 35: "T", 50: "T", 65: "T", 80: "T", 100: "T" } },
    period_km: 5000,
  },
  {
    system: "PEU",
    item: "Check controller surface and vent valve",
    action_cycle: { default: "I" },
    period_km: 5000,
  },

  // ── PDU ──
  {
    system: "PDU",
    item: "Check coolant leakage (PDU)",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Beijing SinoHytec",
  },
  {
    system: "PDU",
    item: "PDU mounting bolts",
    action_cycle: { default: "I", intervals: { 15: "T", 35: "T", 50: "T", 65: "T", 80: "T", 100: "T" } },
    period_km: 5000,
    remark: "Beijing SinoHytec",
  },
  {
    system: "PDU",
    item: "PDU enclosure grounding wire",
    action_cycle: { default: "I", intervals: { 15: "T", 35: "T", 50: "T", 65: "T", 80: "T", 100: "T" } },
    period_km: 5000,
    remark: "Beijing SinoHytec",
  },
  {
    system: "PDU",
    item: "PDU cover plate fastening",
    action_cycle: { default: "I", intervals: { 15: "T", 35: "T", 50: "T", 65: "T", 80: "T", 100: "T" } },
    period_km: 5000,
    remark: "Beijing SinoHytec",
  },

  // ── DCL ──
  {
    system: "DCL",
    item: "DCL controller surface and vent valve",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Beijing SinoHytec",
  },
  {
    system: "DCL",
    item: "DCL high and low voltage connectors",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "REFIRE",
  },
  {
    system: "DCL",
    item: "DCL mounting bolts",
    action_cycle: { default: "I", intervals: { 15: "T", 35: "T", 50: "T", 65: "T", 80: "T", 100: "T" } },
    period_km: 5000,
    remark: "REFIRE",
  },

  // ── VCU ──
  {
    system: "VCU",
    item: "Installation of VCU",
    action_cycle: { default: "I", intervals: { 10: "T", 20: "T", 30: "T", 40: "T", 50: "T", 60: "T", 70: "T", 80: "T", 90: "T", 100: "T" } },
    period_km: 5000,
  },
  {
    system: "VCU",
    item: "Appearance of VCU",
    action_cycle: { default: "I" },
    period_km: 5000,
  },

  // ── Electric Air Compressor ──
  {
    system: "Electric Air Compressor",
    item: "Primary air filter element",
    action_cycle: { default: "I", intervals: { 5: "R", 35: "R", 65: "R", 100: "R" } },
    period_km: 5000,
    remark: "Replace every 30,000 km or monthly after first maintenance",
  },
  {
    system: "Electric Air Compressor",
    item: "Secondary air filter element",
    action_cycle: { default: "I", intervals: { 5: "R", 35: "R", 65: "R", 100: "R" } },
    period_km: 5000,
    remark: "Replace every 30,000 km or monthly after first maintenance",
  },
  {
    system: "Electric Air Compressor",
    item: "Connectors, fasteners, pipes, joints",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or monthly",
  },
  {
    system: "Electric Air Compressor",
    item: "Shock pad",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or monthly",
  },
  {
    system: "Electric Air Compressor",
    item: "Oil cooler, fan, nose and motor surfaces",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or monthly",
  },
  {
    system: "Electric Air Compressor",
    item: "Lubricating oil",
    action_cycle: { default: "I", intervals: { 5: "R", 35: "R", 65: "R", 100: "R" } },
    period_km: 5000,
    remark: "Replace every 30,000 km or monthly",
  },
  {
    system: "Electric Air Compressor",
    item: "Oil filter",
    action_cycle: { default: "I", intervals: { 5: "R", 35: "R", 65: "R", 100: "R" } },
    period_km: 5000,
    remark: "Replace every 30,000 km",
  },
  {
    system: "Electric Air Compressor",
    item: "Air compressor intake pipe",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or annually",
  },
  {
    system: "Electric Air Compressor",
    item: "Function of control valve system",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or monthly",
  },
  {
    system: "Electric Air Compressor",
    item: "Leakage of pipes and connection parts",
    action_cycle: { default: "I", intervals: { 5: "T", 15: "T", 25: "T", 35: "T", 45: "T", 55: "T", 65: "T", 75: "T", 85: "T", 100: "T" } },
    period_km: 5000,
    remark: "Or monthly",
  },

  // ── Main Brake ──
  {
    system: "Main Brake",
    item: "Excessive wear of wheel brake cam",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or monthly",
  },
  {
    system: "Main Brake",
    item: "Stroke of brake chamber push rod",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or monthly",
  },
  {
    system: "Main Brake",
    item: "Function of brake chamber",
    action_cycle: { default: "-", intervals: { 30: "R", 70: "R" } },
    period_km: 30000,
    remark: "Or annually",
  },
  {
    system: "Main Brake",
    item: "Wear of friction lining",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or monthly",
  },
  {
    system: "Main Brake",
    item: "Wear and damage of brake drum",
    action_cycle: { default: "-", intervals: { 30: "I", 70: "I" } },
    period_km: 30000,
    remark: "Or annually",
  },
  {
    system: "Main Brake",
    item: "Clearance of adjusting arm",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or monthly",
  },
  {
    system: "Main Brake",
    item: "Function of adjusting arm",
    action_cycle: { default: "L" },
    period_km: 5000,
    remark: "Or monthly",
  },
  {
    system: "Main Brake",
    item: "Replace brake hose (frame to axle)",
    action_cycle: { default: "-", intervals: { 30: "R", 70: "R" } },
    period_km: 30000,
    remark: "Or annually",
  },
  {
    system: "Main Brake",
    item: "Check brake hose for damage/looseness",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or monthly",
  },
  {
    system: "Main Brake",
    item: "Desiccant in air dryer (drying cylinder)",
    action_cycle: { default: "-", intervals: { 15: "R", 55: "R", 80: "R" } },
    period_km: 15000,
    remark: "Or every 6 months / when air reservoir has water",
  },
  {
    system: "Main Brake",
    item: "Air dryer",
    action_cycle: { default: "-", intervals: { 100: "R" } },
    period_km: 100000,
    remark: "Or annually",
  },

  // ── Parking Brake ──
  {
    system: "Parking Brake",
    item: "Function of control valve system",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or monthly",
  },
  {
    system: "Parking Brake",
    item: "Wear of friction lining",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or annually",
  },
  {
    system: "Parking Brake",
    item: "Stroke of spring brake chamber push rod",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or monthly",
  },

  // ── Drive Axle ──
  {
    system: "Drive Axle",
    item: "Change drive axle lubricating oil",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or annually",
  },
  {
    system: "Drive Axle",
    item: "Change hub lubricating oil",
    action_cycle: { default: "I" },
    period_km: 5000,
    remark: "Or annually",
  },
];

// Compute upcoming services for a vehicle given its odometer (km)
export function getUpcomingServices(odometerKm) {
  const results = [];

  for (const svc of SERVICE_SCHEDULE) {
    if (!svc.period_km) continue;

    const currentInterval = Math.floor(odometerKm / svc.period_km);
    const nextServiceKm = (currentInterval + 1) * svc.period_km;
    const kmRemaining = nextServiceKm - odometerKm;
    const progress = ((odometerKm % svc.period_km) / svc.period_km) * 100;

    // Determine action type at next service
    const intervalKey = nextServiceKm / 1000;
    const action =
      svc.action_cycle.intervals && svc.action_cycle.intervals[intervalKey]
        ? svc.action_cycle.intervals[intervalKey]
        : svc.action_cycle.default;

    if (action === "-") continue; // no service at this interval

    results.push({
      system: svc.system,
      item: svc.item,
      action,
      nextServiceKm,
      kmRemaining,
      progress,
      remark: svc.remark || null,
      urgency:
        kmRemaining <= 500
          ? "critical"
          : kmRemaining <= 1500
          ? "warning"
          : kmRemaining <= 3000
          ? "upcoming"
          : "ok",
    });
  }

  // Sort by urgency: critical first, then warning, upcoming, ok
  const urgencyOrder = { critical: 0, warning: 1, upcoming: 2, ok: 3 };
  results.sort((a, b) => urgencyOrder[a.urgency] - urgencyOrder[b.urgency] || a.kmRemaining - b.kmRemaining);

  return results;
}

// Compute service status (overdue/due/ok) per item, given the odometer and a
// log of past completions for this vehicle. `log` rows: {system, item, done_at_km}.
// Returns one row per schedule item: { system, item, action, period_km,
// last_done_km, next_due_km, km_to_due (positive = ahead, negative = overdue),
// status, action_label }.
export function computeServiceStatus(odometerKm, log = []) {
  // Index latest done_at_km per (system, item)
  const latestDone = new Map();
  for (const r of log) {
    const k = `${r.system}|${r.item}`;
    const cur = latestDone.get(k);
    const km = Number(r.done_at_km);
    if (!cur || km > cur) latestDone.set(k, km);
  }

  const out = [];
  for (const svc of SERVICE_SCHEDULE) {
    if (!svc.period_km) continue;
    const k = `${svc.system}|${svc.item}`;
    const last_done_km = latestDone.has(k) ? latestDone.get(k) : null;
    const baseline = last_done_km != null
      ? last_done_km
      : Math.floor(odometerKm / svc.period_km) * svc.period_km;
    const next_due_km = baseline + svc.period_km;
    const km_to_due = next_due_km - odometerKm;
    // Use the default action for the upcoming interval; fall back to default.
    const intervalKey = next_due_km / 1000;
    const action =
      (svc.action_cycle.intervals && svc.action_cycle.intervals[intervalKey]) ||
      svc.action_cycle.default;
    let status;
    if (km_to_due > 1500)       status = "ok";
    else if (km_to_due > 0)     status = "due_soon";
    else if (km_to_due > -500)  status = "due";
    else                        status = "overdue";
    out.push({
      system: svc.system,
      item: svc.item,
      action,
      action_label: ACTION_LABELS[action] || action,
      period_km: svc.period_km,
      last_done_km,
      next_due_km,
      km_to_due,
      status,
    });
  }
  // Sort: overdue/due first, then due_soon, then ok; within each, smallest km_to_due first
  const order = { overdue: 0, due: 1, due_soon: 2, ok: 3 };
  out.sort((a, b) => order[a.status] - order[b.status] || a.km_to_due - b.km_to_due);
  return out;
}

// Action code to human-readable label
export const ACTION_LABELS = {
  I: "Inspect",
  A: "Adjust",
  R: "Replace",
  T: "Tighten",
  L: "Lubricate",
};

export default SERVICE_SCHEDULE;
